module.exports = __webpack_public_path__ + "img/elementwidths_jaka.5f048795.png";